Space1.UI.globalModalLoadAnimation = null;
Space1.UI.uploaderSas = null;
$(document).ready(function () {
    function resizeModalLoadAnimation(modal, loadAnim) {
        const $modal = $(modal);
        const modalContentHeight = $modal.find('.modal-content').height();
        loadAnim.vars.$container[0].style.height = modalContentHeight + 'px';
    }

    function modalInit(modal, eventTrigger) {
        const $modal = $(modal);

        $('.selectpicker').selectpicker();

        $("form").each(function () {
            if (!this.hasAttribute('novalidate')) {
                $.validator.unobtrusive.parse($(this));
                $(this).bind("submit", disableButtons);
            }
        });

        //upload-zone
        checkIfModalHasAnUploadZoneAndInit(modal);

        Space1.UI.Modal.initFullscreenButtons(modal);

        Space1.UI.colorPicker.newFactory('.sp-color-picker');

        Space1.UI.initTooltips();

        Space1.UI.vTabs.initListeners();
        Space1.UI.Tabs.initAnchorNavigation();
        Space1.UI.Tabs.initScrollableTabs();

        Space1.UI.DateTimePicker.newPicker(`#${$modal.attr('id')} [data-datetime-input]`, $modal[0]);
        Space1.UI.DateTimePicker.newPicker(`#${$modal.attr('id')} input[type=time]`, $modal[0]);
        //Space1.UI.initDateTimePicker('#' + $modal.attr('id') +' input[type=date]', $modal[0]);
    }

    $(".modal").on('show.bs.modal', function (e) {
        let modal = this;
        let $modal = $(modal);

        Space1.UI.Modal.addModalToStack($(this).attr("id"));

        Space1.UI.videoPlayer.pauseAll();

        $modal.find(".modal-dialog .overlay-loader").remove();

        if (!$modal.hasClass('js-no-load-animation')) {
            Space1.UI.globalModalLoadAnimation.start();
        } else {
            Space1.UI.globalModalLoadAnimation.stop();
        }

    }).on('loaded.bs.modal', function (e) {
        modalInit(this, e);
        Space1.UI.globalModalLoadAnimation.stop();
        resizeModalLoadAnimation(this, Space1.UI.globalModalLoadAnimation);

        Space1.UI.globalModalLoadAnimation.vars.$container.on('progress', () => {
            $(this).addClass('not-closable', false);
        });

        Space1.UI.globalModalLoadAnimation.vars.$container.on('start', () => {
            resizeModalLoadAnimation(this, Space1.UI.globalModalLoadAnimation);
        });

        Space1.UI.globalModalLoadAnimation.vars.$container.on('stop', () => {
            $(this).removeClass('not-closable');
        });

    }).on('reloaded.bs.modal', function (e) {
        modalInit(this, e);

    }).on('hide.bs.modal', function (e) {
        if ($(this).hasClass('not-closable')) {
            e.preventDefault();
            e.stopImmediatePropagation();
        } else {
            Space1.UI.Modal.removeModalFromStack($(this).attr("id"));
            $(this).find('.bootstrap-select.open').find('.selectpicker').selectpicker('toggle');
        }
    }).on('hidden.bs.modal', function (e) {

        if (!$(this).hasClass('js-disable-modal-destroy')) {
            $(this).removeData('bs.modal');
            if (Space1.UI.globalModalLoadAnimation !== undefined && Space1.UI.globalModalLoadAnimation !== null) {
                Space1.UI.globalModalLoadAnimation.destroy();
            }
            setTimeout(() => {
                $(this).find('.summernote').summernote('destroy');
                $(this).find('.modal-content:not(.js-modal-content)').children().remove();
            }, 100);

            $(this).find("*").off();
        }

        Space1.UI.videoPlayer.pauseAll();

        if (Space1.UI.uploaderSas != null) {
            Space1.UI.uploaderSas.destroy();
            Space1.UI.uploaderSas = null;
        }
    });
});

function disableButtons(e) {
    console.log(e);
    const form = $(this);
    if (form.data("uploadzone"))
        return;

    const btns = $("button:submit", form);

    if (!form.valid()) {
        // allow user to correct validation errors and re-submit
        btns.removeAttr("disabled");
    } else {
        btns.attr("disabled", "disabled");
    }
}

/**
 * If Modal Has UploadZone data attribute =true
 * Init the upload-zone helper
 *
 * @param {any} modal
 */
function checkIfModalHasAnUploadZoneAndInit(modal) {
    const form = $(modal).find("form");
    const autoInit = $(form).data("uploadzoneAutoInit");

    if ($(form).data("uploadzone") == true && autoInit != false) {
        Space1.UI.uploaderSas = new Space1.Util.UploadZone({
            form: form[0]
        });
    }
}

/* Check if input has changed inside modals
* Enable submit button only when there's a change in the inputs
* */
function checkModalInputStatus(modal) {
    let submitButton, form, checkModal;

    /* add to this list selectors of elements that should disable the input checking */
    const disableStatusCheckFor = [
        "#additional-fields-form",
        ".no-modal-status-check",
        "#openSearch",
        ".dropzone",
        ".upload-zone",
        "#btnChooseFailureTarget",
        "#btnChooseSuccessTarget",
        "#disableModalCheck",
        "#add_edit_webhookconfiguration",
        "#manage-user-license",
        "#showimagedetails"
    ];

    function isModalInputCheckable() {
        let atLeastOneEditableInput = modal.find("input:not([type=hidden])").length > 0;
        let foundSelectorAgainstValidation = disableStatusCheckFor.some(selectorAgainstValidation => {
            if (modal.find(selectorAgainstValidation).length > 0) {
                console.log(`Found selector ${selectorAgainstValidation} against modal input change check in ${modal[0].id}`);
                return true;
            } else {
                return false;
            }
        });

        if (atLeastOneEditableInput && !foundSelectorAgainstValidation) {
            console.log("Enabled modal input change check");
            return true;
        } else {
            console.log("Disabled modal input change check");
            return false;
        }
    }

    modal.on('loaded.bs.modal', function (e) {
        setTimeout(function () {
            form = modal.find("form");
            submitButton = modal.find("#btn-submit");
            checkModal = isModalInputCheckable();

            if (checkModal && form && submitButton) {

                submitButton.prop("disabled", true);

                form.dirty({
                    preventLeaving: false
                }).on("dirty", function () {

                    submitButton.prop("disabled", false);
                    modal.data("bs.modal").options.backdrop = 'static';
                    modal.data("bs.modal").options.keyboard = false;
                    modal.off('keydown.dismiss.bs.modal');
                    console.log("Modal input is dirty.");

                }).on("clean", function () {

                    submitButton.prop("disabled", true);
                    modal.data("bs.modal").options.backdrop = true;
                    modal.data("bs.modal").options.keyboard = true;
                    modal.data("bs.modal").escape();
                    console.log("Modal input is clean.");

                });

                // disable dirrty checks when submit is managed by other scripts
                submitButton.one('click', function (e) {
                    e.preventDefault();
                    form.dirty("setAsClean");
                    $(this).submit();
                });

            }
        }, 250);

    }).on('hide.bs.modal', function (e) {
        if (checkModal) {
            //form.dirty("setClean");
        }
    });
}
